import React from 'react'
import { IconButton, H1, Row, Cell } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'
import { string, bool } from 'prop-types'

const PWAHeader = ({ title, backDestination = '/more', showBack = false }) => {
  return (
    <Row gutters="none" alignY="middle">
      {showBack && <IconButton to={backDestination} title="Back" Icon={ArrowCaret} iconDirection="backward" />}
      <Cell growX>
        <H1 size="H3" centered>
          {title}
        </H1>
      </Cell>
    </Row>
  )
}

export default PWAHeader

PWAHeader.propTypes = {
  title: string,
  backDestination: string,
  showBack: bool,
}
